
      import API from "!../../style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../style-loader/dist/runtime/styleDomAPI.js";
      import insertFn from "!../../style-loader/dist/runtime/insertBySelector.js";
      import setAttributes from "!../../style-loader/dist/runtime/setAttributesWithoutAttributes.js";
      import insertStyleElement from "!../../style-loader/dist/runtime/insertStyleElement.js";
      import styleTagTransformFn from "!../../style-loader/dist/runtime/styleTagTransform.js";
      import content, * as namedExport from "!!../../css-loader/dist/cjs.js??ruleSet[1].rules[4].use[1]!./virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{\"fileName\":\"app/components/product-detail/product-info/nutritional-modal/styles.css.ts.vanilla.css\",\"source\":\"Ll8xamtmejJrMCB7CiAgdGV4dC1hbGlnbjogcmlnaHQ7CiAgcGFkZGluZzogMTBweDsKICBtaW4td2lkdGg6IDE1MHB4OwogIHdpZHRoOiAxNTBweDsKfQouXzFqa2Z6MmswOmZpcnN0LW9mLXR5cGUgewogIHRleHQtYWxpZ246IGxlZnQ7CiAgd2lkdGg6IDE4MHB4OwogIG1pbi13aWR0aDogMTgwcHg7CiAgcGFkZGluZy1sZWZ0OiAxNXB4Owp9Ci5fMWprZnoyazE6bnRoLW9mLXR5cGUob2RkKSB7CiAgYmFja2dyb3VuZC1jb2xvcjogcmdiYSgwLDAsMCwuMDUpOwp9\"}!./extracted.js";
      
      

var options = {};

options.styleTagTransform = styleTagTransformFn;
options.setAttributes = setAttributes;

      options.insert = insertFn.bind(null, "head");
    
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../../css-loader/dist/cjs.js??ruleSet[1].rules[4].use[1]!./virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{\"fileName\":\"app/components/product-detail/product-info/nutritional-modal/styles.css.ts.vanilla.css\",\"source\":\"Ll8xamtmejJrMCB7CiAgdGV4dC1hbGlnbjogcmlnaHQ7CiAgcGFkZGluZzogMTBweDsKICBtaW4td2lkdGg6IDE1MHB4OwogIHdpZHRoOiAxNTBweDsKfQouXzFqa2Z6MmswOmZpcnN0LW9mLXR5cGUgewogIHRleHQtYWxpZ246IGxlZnQ7CiAgd2lkdGg6IDE4MHB4OwogIG1pbi13aWR0aDogMTgwcHg7CiAgcGFkZGluZy1sZWZ0OiAxNXB4Owp9Ci5fMWprZnoyazE6bnRoLW9mLXR5cGUob2RkKSB7CiAgYmFja2dyb3VuZC1jb2xvcjogcmdiYSgwLDAsMCwuMDUpOwp9\"}!./extracted.js";
       export default content && content.locals ? content.locals : undefined;
